div.toastContainer {
	--toastify-color-info: #006b9b;
	--toastify-color-progress-info: var(--toastify-color-info);
	--toastify-color-success: #5d9962;
	--toastify-color-progress-success: var(--toastify-color-success);
	--toastify-color-warning: #bd8700;
	--toastify-color-progress-warning: var(--toastify-color-warning);
	--toastify-color-error: #ff5948;
	--toastify-color-progress-error: var(--toastify-color-error);
	--toastify-text-color-light: #515151;
	width: 500px;
	max-width: 100%;
}

div.toastContainerCompact {
	margin-top: 15px;
}

.toastContainer :global(.Toastify__toast-icon) {
	width: 32px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.toastContainer :global(.Toastify__progress-bar) {
	height: 3px;
	animation: toasterProgressAnimation linear 1 forwards;
}

.toastMessage.small {
	width: 330px;
	margin-left: auto;
	margin-right: auto;
}

.toastContent {
	display: flex;
	align-items: center;
}

.toastContent::before {
	content: "";
	border-left: 1px solid #cfcfcf;
	height: 23px;
}

.toastTextWrapper {
	display: flex;
	flex-direction: column;
	font-size: 13px;
	padding-left: 12px;
}

button.closeButton {
	align-self: start;
	color: #222222;
	padding: 2px;
}

@keyframes toasterProgressAnimation {
	0% {
		transform: scaleX(0);
	}

	100% {
		transform: scaleX(1);
	}
}
